import { type TimeData } from '@pkg/utils';

export interface TimeAgoLabelOptions {
    preferDaysOverWeeks?: boolean;
    variant?: 'full' | 'shorthand' | 'compact';
}

// TODO: Consider converting all strings to use `i18n`.

function getLabelFull(
    { years, months, weeks, days, hours, minutes, seconds, past = false }: TimeData,
    preferDaysOverWeeks = false,
) {
    const suffix = past ? 'ago' : 'until';

    if (years) return `${years} years ${suffix}`;
    if (months) return `${months} months ${suffix}`;

    if (weeks && !preferDaysOverWeeks) return `${weeks} weeks ${suffix}`;

    if (days) return `${days} days ${suffix}`;
    if (hours) return `${hours} hours ${suffix}`;
    if (minutes) return `${minutes} minutes ${suffix}`;
    if (seconds) return `${seconds} seconds ${suffix}`;

    return 'Just now';
}

function getLabelShorthand(
    { years, months, weeks, days, hours, minutes, seconds, past = false }: TimeData,
    preferDaysOverWeeks = false,
) {
    const suffix = past ? 'ago' : 'until';

    if (years) return `${years}y ${suffix}`;
    if (months) return `${months}mm ${suffix}`;

    if (weeks && !preferDaysOverWeeks) return `${weeks}w ${suffix}`;

    if (days) return `${days}d ${suffix}`;
    if (hours) return `${hours}h ${suffix}`;
    if (minutes) return `${minutes}m ${suffix}`;
    if (seconds) return `${seconds}s ${suffix}`;

    return 'Just now';
}

function getLabelCompact(
    { years, months, weeks, days, hours, minutes, seconds }: TimeData,
    preferDaysOverWeeks = false,
) {
    if (years) return `${years}y`;
    if (months) return `${months}mm`;

    if (weeks && !preferDaysOverWeeks) return `${weeks}w`;

    if (days) return `${days}d`;
    if (hours) return `${hours}h`;
    if (minutes) return `${minutes}m`;
    if (seconds) return `${seconds}s`;

    return 'Now';
}

export function timeAgoLabel(time: TimeData, { preferDaysOverWeeks = false, variant = 'full' }: TimeAgoLabelOptions) {
    if (variant === 'compact') return getLabelCompact(time, preferDaysOverWeeks);
    if (variant === 'shorthand') return getLabelShorthand(time, preferDaysOverWeeks);
    return getLabelFull(time, preferDaysOverWeeks);
}
